import { ArrowRight, Check } from "lucide-react";
import { pricingContent } from "@/app/content/landingContent";

export function PricingSection() {
  return (
    <section
      id="pricing"
      className="py-20 md:py-24 px-6 bg-gray-50"
      aria-labelledby="pricing-heading"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2
            id="pricing-heading"
            className="text-[clamp(1.875rem,4vw,3rem)] text-slate-900 mb-6 tracking-tight font-bold"
          >
            {pricingContent.heading}
          </h2>
          <p className="text-[clamp(1.125rem,2vw,1.25rem)] text-slate-600 leading-relaxed max-w-prose mx-auto">
            {pricingContent.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {pricingContent.packages.map((pkg) => (
            <div
              key={pkg.id}
              className={`rounded-2xl p-8 flex flex-col ${
                pkg.featured
                  ? "bg-slate-900 text-white ring-2 ring-[#004f4f]"
                  : "bg-white text-slate-900 border border-gray-200"
              }`}
            >
              {pkg.featured && (
                <p className="text-xs font-semibold text-[#4db6ac] uppercase tracking-widest mb-4">
                  Najpopularniejszy
                </p>
              )}

              <h3 className={`text-xl font-bold mb-2 ${pkg.featured ? "text-white" : "text-slate-900"}`}>
                {pkg.name}
              </h3>

              <p className={`text-sm leading-relaxed mb-6 ${pkg.featured ? "text-slate-400" : "text-slate-500"}`}>
                {pkg.description}
              </p>

              <div className="mb-6">
                <span className={`text-3xl font-bold ${pkg.featured ? "text-white" : "text-slate-900"}`}>
                  {pkg.price}
                </span>
                <span className={`text-sm ml-1 ${pkg.featured ? "text-slate-400" : "text-slate-500"}`}>
                  {pkg.priceNote}
                </span>
              </div>

              <ul className="space-y-3 mb-8 flex-1">
                {pkg.items.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm leading-relaxed">
                    <Check
                      size={16}
                      className={`mt-0.5 flex-shrink-0 ${pkg.featured ? "text-[#4db6ac]" : "text-[#004f4f]"}`}
                      aria-hidden="true"
                    />
                    <span className={pkg.featured ? "text-slate-300" : "text-slate-600"}>{item}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-semibold text-sm transition-colors focus:outline-none focus:ring-4 focus:ring-offset-2 ${
                  pkg.featured
                    ? "bg-[#004f4f] text-white hover:bg-[#003d3d] focus:ring-[#004f4f] focus:ring-offset-slate-900"
                    : "bg-slate-900 text-white hover:bg-slate-700 focus:ring-slate-900"
                }`}
              >
                {pkg.cta}
                <ArrowRight size={16} aria-hidden="true" />
              </a>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-slate-500 max-w-2xl mx-auto">
          {pricingContent.note}
        </p>
      </div>
    </section>
  );
}
